import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="mt-32"
      style={{ background: "var(--bg-soft)" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 grid md:grid-cols-4 gap-12">
        <div>
          <img loading="lazy" decoding="async" src="/img/9ab2fa8bea.webp" alt="1000 ARTS" className="h-16 w-auto" />
          <p className="mt-4 text-sm text-[var(--muted)] leading-relaxed italic">1 style, le tien.</p>
          <p className="mt-3 text-sm text-[var(--muted)] leading-relaxed">
            École de danse, chant et comédie musicale à Cugy (VD).
          </p>
        </div>

        <div>
          <div className="eyebrow mb-4">Navigation</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/cours" data-testid="footer-link-cours" className="hover:text-[var(--primary)] text-[var(--muted)]">Nos cours</Link></li>
            <li><Link to="/planning" data-testid="footer-link-planning" className="hover:text-[var(--primary)] text-[var(--muted)]">Planning</Link></li>
            <li><Link to="/dates-importantes" data-testid="footer-link-dates-importantes" className="hover:text-[var(--primary)] text-[var(--muted)]">Dates importantes</Link></li>
            <li><Link to="/stages" data-testid="footer-link-stages" className="hover:text-[var(--primary)] text-[var(--muted)]">Stages</Link></li>
            <li><Link to="/actualites" data-testid="footer-link-actualites" className="hover:text-[var(--primary)] text-[var(--muted)]">Actualités</Link></li>
            <li><Link to="/tarifs" data-testid="footer-link-tarifs" className="hover:text-[var(--primary)] text-[var(--muted)]">Tarifs</Link></li>
            <li><Link to="/inscription" data-testid="footer-link-inscription" className="hover:text-[var(--primary)] text-[var(--muted)]">Inscriptions</Link></li>
            <li><Link to="/competition" data-testid="footer-link-competition" className="hover:text-[var(--primary)] text-[var(--muted)]">Compétition</Link></li>
            <li><Link to="/sponsoring" data-testid="footer-link-sponsoring" className="hover:text-[var(--primary)] text-[var(--muted)]">Sponsoring</Link></li>
            <li><Link to="/assurances" data-testid="footer-link-assurances" className="hover:text-[var(--primary)] text-[var(--muted)]">Assurances SWICA</Link></li>
            <li><Link to="/mon-avs" data-testid="footer-link-mon-avs" className="hover:text-[var(--primary)] text-[var(--muted)]">Transmettre mon n° AVS</Link></li>
            <li><Link to="/desinscription" data-testid="footer-link-desinscription" className="hover:text-[var(--primary)] text-[var(--muted)]">Arrêter les cours</Link></li>
            <li><Link to="/reglement" data-testid="footer-link-reglement" className="hover:text-[var(--primary)] text-[var(--muted)]">Règlement intérieur</Link></li>
            <li><Link to="/reglement-competition" data-testid="footer-link-reglement-competition" className="hover:text-[var(--primary)] text-[var(--muted)]">Règlement Compétition</Link></li>
            <li><Link to="/mentions-legales" data-testid="footer-link-mentions-legales" className="hover:text-[var(--primary)] text-[var(--muted)]">Mentions légales &amp; données</Link></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow mb-4">Contact</div>
          <ul className="space-y-3 text-sm text-[var(--muted)]">
            <li className="flex items-start gap-3"><MapPin size={16} className="mt-1 shrink-0 text-[var(--primary)]" /> Chemin des Dailles 10E, 1053 Cugy</li>
            <li className="flex items-center gap-3"><Phone size={16} className="text-[var(--primary)]" /> <a href="tel:+41799504031" className="hover:underline" data-testid="footer-tel">079 950 40 31</a></li>
            <li className="flex items-center gap-3"><Mail size={16} className="text-[var(--primary)]" /> <a href="mailto:info1000arts@gmail.com" className="hover:underline break-all" data-testid="footer-mail">info1000arts@gmail.com</a></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow mb-4">Suis-nous</div>
          <a
            href="https://www.instagram.com/1000artsofficiel/"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-instagram"
            className="inline-flex items-center gap-3 text-sm hover:text-[var(--primary)] text-[var(--muted)]"
          >
            <Instagram size={18} /> @1000artsofficiel
          </a>
        </div>
      </div>

      <div className="border-t border-[var(--border-soft)] py-6 px-6 flex flex-col md:flex-row items-center justify-center gap-2 md:gap-3 text-center text-xs text-[var(--muted)]">
        <span>© {new Date().getFullYear()} 1000 ARTS · 1 style, le tien · Tous droits réservés</span>
        <span className="hidden md:inline text-[var(--border)]">·</span>
        <Link to="/mentions-legales" data-testid="footer-legal-bottom" className="hover:text-[var(--primary)] underline">
          Mentions légales &amp; confidentialité
        </Link>
        <span className="hidden md:inline text-[var(--border)]">·</span>
        {/* La signature de l'agence : le petit citron se penche au survol (pas d'animation
            si le visiteur a demandé moins de mouvement). */}
        <a
          href="https://heylemon.ch/"
          target="_blank"
          rel="noreferrer"
          data-testid="footer-made-by-lemon"
          aria-label="Site réalisé par l'agence Lemon (heylemon.ch)"
          className="group inline-flex items-center gap-1.5 rounded-full px-3 py-1 transition-colors hover:bg-[#FDF3D2]"
        >
          <span>Made by</span>
          <img
            src="/img/lemon-mascotte.webp"
            alt=""
            width="22"
            height="22"
            loading="lazy"
            decoding="async"
            className="w-[22px] h-[22px] motion-safe:transition-transform motion-safe:duration-300 motion-safe:group-hover:-rotate-12 motion-safe:group-hover:scale-110"
          />
          <span className="font-semibold" style={{ color: "#0B1F3A" }}>Lemon</span>
        </a>
      </div>
    </footer>
  );
}
